import { IABTestContext } from 'config/abTests';

export type AbTestsState = IABTestContext;

const initialState: AbTestsState = {};

export default (state: AbTestsState = initialState) => state;
